import { Grid } from "@mui/material"
import React from "react"
import { GenericTabsMenu, GenericTabsMenuType } from "./GenericTabsMenu"

/**
 * Use Material-UI's tabs to show generic tabs layout
 * 
 * Utilization is more simple
 * 
 * It's coupled with "dirtyForm" system and handle GenericForm dirty automatically
 * 
 * ###Import to use it
 *
 *```
 *   import { GenericTabs } from '@eco/react-lib'
 *```
 *
 *### Usage
 *
 *```jsx
 * <GenericTabs 
 *   label={string} 
 *   description={string}
 * />
 *```
 *
 * ### Basic Example
 * 
 * @deprecated using this component doesn't make sense. The user of this component must handle child component himsefl. Use "GenericTabsMenu" separatly, or use "GenericTabsContainer" if you are in a context of wizard layout
 */

export const GenericTabs = (props: GenericTabsType) => {

    return (
        <Grid container>
            <Grid item xs={12}>
                <GenericTabsMenu 
                    menus={props.menus}
                    autoNavigate={props.autoNavigate} 
                    canNavigate={props.canNavigate} 
                    showNavConfirmation={props.showNavConfirmation}
                    {...props.GenericTabsMenuProps}  
                    />
            </Grid>

            {
                props.children &&
                <Grid item xs={12}>
                    {
                        props.children
                    }
                </Grid>
            }
            
        </Grid>
    )
}

export type GenericTabsType = {
    /** Element currently active */
    children?: React.ReactElement;
    /**
     * @deprecated
     */
    path?: GenericTabsMenuType['path'];
    menus?: GenericTabsMenuType['menus'];
    /**
     * @deprecated
     */
    autoNavigate?: GenericTabsMenuType['autoNavigate'];
    /**
     * @deprecated
     */
    canNavigate?: GenericTabsMenuType['canNavigate'];
    /**
     * @deprecated
     */
    showNavConfirmation?: GenericTabsMenuType['showNavConfirmation'];
    GenericTabsMenuProps?: GenericTabsMenuType;
}
